export enum SortType {
    //None, - consider in future?
    String,
    Number,
    Date,
    Boolean
}
